import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import MoleculeNowTile from "Components/Molecules/NowTile";
import AtomGridContainer from "Components/Atoms/GridContainer";
import AtomGridChild from "Components/Atoms/GridChild";
import styled from "styled-components";

import { api, grid } from "enumerations";
import * as Types from "Types";
import { getGridSize } from "styles";

const Wrap = styled.div<Types.Default>`
   ${({ css }) => css}
`;
export interface PropsType extends Types.Default {}

export default function NowTiles(props: PropsType) {
   const data: Types.Api.ReducerResponse = useSelector((state: any) => state.nows.get);
   const width = useSelector((state: Types.State) => state.dimensions.width);
   const rowGap = getGridSize(width) === grid.sizes.xs ? "25px" : "40px";
   ///${row.uri_title}
   return (
      <Wrap css={props.css} className={props.className}>
         <AtomGridContainer rowGap={rowGap}>
            {data.status === api.resolved &&
               data.data!.map((row: any) => (
                  <AtomGridChild key={row.now_id} sizes={{ xxl: 8, xl: 5, l: 6, m: 2, s: 2, xs: 2 }}>
                     <Link to={`/nows/${row.now_id}/${row.title.replace(/[\s\\/]/giu, "")}`}>
                        <MoleculeNowTile title={row.title} subtitle={row.subtitle} thumbnailUri={row.thumbnail_uri} uriTitle={row.uri_title}></MoleculeNowTile>
                        <Link to={`/nows/${row.now_id}`}></Link>
                     </Link>
                  </AtomGridChild>
               ))}
         </AtomGridContainer>
      </Wrap>
   );
}
